const getLanguageConfigs = () => {
  return {
    English: {
      keyboard: [
        ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
        ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
        ["ENTER", "Z", "X", "C", "V", "B", "N", "M", "BACKSPACE"],
      ],
      wordsUrl: "./english.json",
    },
  };
};

export default getLanguageConfigs;
